export const FEATURE_FLAGS = {
  MOBILE_CHAT_OPTIMIZATION: false,
  MOBILE_KEYBOARD_DETECTION: false,
  COMPRESSED_MOBILE_LAYOUT: false,
  /** Emergency only: restore V206.3 session-based age bypass (skips DB gate). Default false. */
  AGE_GATE_SESSION_BYPASS: false,
};

// Development override via localStorage
if (typeof window !== 'undefined') {
  const devFlags = localStorage.getItem('dev_feature_flags');
  if (devFlags) {
    try {
      Object.assign(FEATURE_FLAGS, JSON.parse(devFlags));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Invalid feature flags in localStorage');
    }
  }
}

